// extracted by mini-css-extract-plugin
export default {"modal":"modal-pkbiM","header":"header-qxBKe","textarea":"textarea-F6tC1","crossIcon":"crossIcon-olHJc","button":"button-xZZCO","white":"white-E1HIa","counter":"counter-eMlfh"};